import { render, staticRenderFns } from "./AboutView.vue?vue&type=template&id=5300ee22&scoped=true&lang=pug&"
import script from "./AboutView.vue?vue&type=script&lang=ts&"
export * from "./AboutView.vue?vue&type=script&lang=ts&"
import style0 from "./AboutView.vue?vue&type=style&index=0&id=5300ee22&scoped=true&lang=scss&"
import style1 from "./AboutView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5300ee22",
  null
  
)

export default component.exports